import { render, staticRenderFns } from "./CodigoPuerta.vue?vue&type=template&id=7980fbd4&"
import script from "./CodigoPuerta.vue?vue&type=script&lang=js&"
export * from "./CodigoPuerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports